// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"f1ae7041","453":"ada6f40a"}[chunkId] + ".chunk.js";
};